import React from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../redux/root-action';
import styled from 'styled-components';
import CheckBadgeIcon from "../../../assets/checkBadgeIcon.svg";

const StyledHeader = styled.div`
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-weight: var(--beacon-font-weight-bold);
  font-size: 28px;
  line-height: 1.29;
  margin-bottom: 16px;
  display: flex;
  @media (max-width: 768px) {
    font-size: 24px;
  }
  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

const StyledModalTitle = styled.div`
  display: flex;
  align-items: center;
`;

const StyledCheckBadgeIcon = styled.img`
  margin-right: 16px;
`;

interface Props {
  modalTitle?: string;
  showClose?: boolean;
  showCloseInMobile?: boolean;
  errorMessage?: string;
  handleCloseIconClick?: () => void;
}

class ReactModalHeader extends React.Component<Props> {
  props: any;
  divElement: HTMLDivElement | null = null;

  handleKeyPress = (e: any) => {
    const btn = document.querySelector('#modal-header-close-icon') as HTMLElement | null;
    if (e.nativeEvent.code === 'Enter') {
      btn && btn.click();
    }
  };

  render(): any {
    const {
      showCheckBadgeIcon,
      modalTitle,
    } = this.props;
    return (
        <div
            ref={(element: HTMLDivElement) => {
              this.divElement = element;
            }}
        >
          <StyledHeader>
            {showCheckBadgeIcon && <StyledCheckBadgeIcon src={CheckBadgeIcon} alt="Close icon" />}

            <StyledModalTitle tabIndex={0}>{modalTitle}</StyledModalTitle>
          </StyledHeader>
        </div>
    );
  }
}

export default connect(null, {
  closeModal: modalActions.closeModal
})(ReactModalHeader);
